import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withCookies } from 'react-cookie';
import { Auth } from "aws-amplify";
import { Button, CircularProgress, Link, Paper, TextField, Typography, withStyles } from '@material-ui/core';
import { getGlobalFirebaseData } from '../../apis/firebase';
import { logoFull } from "../../resources/images";
import { receive_login_error, receive_profile, } from "../../apis/redux/fetchActions";
import APIService from "../../apis/amplify/APIService";
import formHandlerHOC, { isInvalidField } from '../../components/FormHandlerHOC';
import If from '../../components/If';
import { errorBundaryHOC } from '../../components/ErrorBoundary';
import { communicationFailedText } from '../../util/texts';
import { styles } from './styles';
import { ERROR_TYPE, NActionButton } from "../../components/Notification";
import { Close } from "@material-ui/icons";
import Notification from "../../components/Notification";

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            errorText: '',
            showNotification: false,
            notificationType: ERROR_TYPE,
            notificationText: '',
            rememberMe: false,
            requestInProgress: false,
            emailInvalid: false,
            isLoggedIn: props.isLoggedIn || false,
        };
    }

    handleSubmit = async event => {
        event.preventDefault();
        const { history, actions, validateForm, getFormData, getFormStateSync, setIsLoggedIn, setFieldValue } = this.props;
        validateForm();
        const { isValid, ...rest } = getFormStateSync();
        const { email, password } = getFormData(rest);
        actions.receiveLoginError("");
        if (isValid) {
            this.setState({ requestInProgress: true });
            try {
                const signInResponse = await Auth.signIn(email, password);
                actions.receiveProfile({
                    email: signInResponse.attributes.email,
                    first_name: signInResponse.attributes.given_name,
                    last_name: signInResponse.attributes.family_name,
                    phone_number: signInResponse.attributes.phone_number,
                });
                await APIService.registerDevice(getGlobalFirebaseData().deviceToken);
                setIsLoggedIn(true);
                history.replace('/fix/devices');
            } catch (e) {
                if (e.code === "NotAuthorizedException") {
                    setFieldValue('password', '').updateState();
                    actions.receiveLoginError(e.message);
                } else if (e.code === 'NetworkError') {
                    actions.receiveLoginError(communicationFailedText);
                } else {
                    this.setState({
                        showNotification: true,
                        notificationText: 'We had a problem getting in. Please try again.'
                    });
                }
                this.setState({ requestInProgress: false, });
                setIsLoggedIn(false);
            }
        }
    };

    onRegister = event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        this.props.history.replace('/register');
    };

    goToHome() {
        this.props.history.replace('/fix/devices');
    }

    render() {
        const {
            classes,
            loginErrorText,
            onFormChange,
            formState: {
                isValid, isPristine, email, password,
            },
        } = this.props;
        const { requestInProgress, notificationText, showNotification, notificationType } = this.state;
        return (
            <div>
                <div className={classes.background}>
                    <div className={classes.logoContainer}>
                        <img src={logoFull} alt='' className={classes.logoImage}
                             onClick={this.goToHome.bind(this)}/>
                    </div>
                </div>
                <main className={classes.main}>
                    <Paper className={classes.paper}>
                        <Typography variant="h5" className={classes.signInText}>
                            Sign in
                        </Typography>
                        <br/>
                        <form className="loginForm" onSubmit={this.handleSubmit}>
                            <TextField name="email"
                                       value={email.value}
                                       error={isInvalidField(email)}
                                       onChange={onFormChange}
                                       margin='normal'
                                       label='Email'
                                       fullWidth
                                       type='email'
                                       autoComplete="email"
                                       autoFocus/>
                            <TextField name="password"
                                       value={password.value}
                                       error={isInvalidField(password)}
                                       onChange={onFormChange}
                                       margin='normal'
                                       label='Password'
                                       fullWidth
                                       type='password'
                                       autoComplete="current-password"/>

                            <Typography color="error">
                                {loginErrorText}
                            </Typography>

                            <Button
                                disabled={requestInProgress || !isValid || isPristine}
                                fullWidth
                                variant="contained"
                                color="secondary"
                                className={classes.submit}
                                type='submit'>
                                Sign in
                                <If as={CircularProgress}
                                    condition={requestInProgress}
                                    size={20} id='progress'/>
                            </Button>

                            <Button
                                fullWidth
                                variant="outlined"
                                color="primary"
                                className={classes.register}
                                onClick={this.onRegister}>
                                Create Account
                            </Button>
                            <Link className={classes.rememberLink} underline='always' color="secondary"
                                  onClick={() => this.props.history.replace('/recover_password')}>
                                Can't remember your password?
                            </Link>

                            <Notification open={showNotification}
                                          type={notificationType}
                                          ActionButton={
                                              <NActionButton key="close" ariaLabel="close"
                                                             onClick={() => this.setState({ showNotification: false })}>
                                                  <Close/>
                                              </NActionButton>}
                                          onClose={() => this.setState({ showNotification: false })}>
                                {notificationText}
                            </Notification>
                        </form>
                    </Paper>
                </main>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loginErrorText: state.loginErrorText,
    }
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        receiveLoginError: receive_login_error,
        receiveProfile: receive_profile,
    }, dispatch)
});

const LoginWithForm = formHandlerHOC({
    rules: { email: 'required|email', password: 'required' },
})(Login);

const Wrapped = withCookies((withStyles(styles)(LoginWithForm)));
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC(Wrapped));
